const clickedItems = new Set();

function addToCartAndCheckout(variantId) {
  if (clickedItems.has(variantId)) {
    console.log('Item has already been clicked');
    return;
  }

  clickedItems.add(variantId);

  var buttons = document.querySelectorAll('.ksw-prodcomp__purchase-btn');
  buttons.forEach(button => {
    button.disabled = true;
  });

  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const alreadyInCart = data.items.some(item => item.variant_id === parseInt(variantId));
      if (alreadyInCart) {
        console.log('Item is already in cart');
        window.location.href = '/checkout';
        return;
      }

      if (data.items.length > 0) {
        const removePromises = data.items.map(item => {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          });
        });

        Promise.all(removePromises)
          .then(() => {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                items: [{
                  id: variantId,
                  quantity: 1
                }]
              })
            });
          })
          .then(response => response.json())
          .then(data => {
            console.log('Item added to cart');
            window.location.href = '/checkout';
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
            buttons.forEach(button => {
              button.disabled = false;
            });
            clickedItems.delete(variantId);
          });
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Item added to cart');
          window.location.href = '/checkout';
        })
        .catch(error => {
          console.error('Error adding item to cart:', error);
          buttons.forEach(button => {
            button.disabled = false;
          });
          clickedItems.delete(variantId);
        });
      }
    })
    .catch(error => {
      console.error('Error getting cart:', error);
      buttons.forEach(button => {
        button.disabled = false;
      });
      clickedItems.delete(variantId);
    });
}

document.querySelectorAll('.ksw-prodcomp__purchase-btn').forEach(button => {
  button.addEventListener('click', function() {
    addToCartAndCheckout(this.dataset.variantId);
  });
});
